export default {
    'pcr-units': 'PCR Units',
    resource: 'Unit',
    value: 'Value',
    type: 'Type',
    sort_order: 'Sort order',
    is_active: 'Active',
    is_default: 'Default',
};
